import { createLogic } from 'redux-logic';
import { siteLoad, siteLoaded } from '../actions';
import { apiGet } from '../api';

const loadSite = createLogic({
    type: siteLoad,
    latest: true,
    async process(_, dispatch, done) {
        try {
            const result = await apiGet('sites/admin');

            dispatch(siteLoaded({ ...result.data, siteExists: true }));
        } catch (error) {
            if (error.response && error.response.status === 404) {
                dispatch(siteLoaded({ siteExists: false }));
            }
        } finally {
            done();
        }
    },
});

export default [loadSite];
